import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  card: {
    position: 'absolute',
    width: 348,
    borderRadius: 16,
    padding: 16,
    gap: 16,
  },
  topCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  bottomCard: {
    alignItems: 'flex-end',
  },
  illustration: {
    width: 32,
    height: 32,
  },
  text: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 18,
    color: neutrals.black,
  },
  ctaText: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.white,
  },
});
